import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Objects } from '../../../util/objects';
import { Values } from '../../../util/values';
import { ClassifiedItemTypes } from '../../../type/classified-item-type';

@Component({
  selector: 'ngx-classification-item-state-column',
  template: `<ngx-tag value="{{params.value}}" status="{{status}}"></ngx-tag>`,
  encapsulation: ViewEncapsulation.None,
})
export class ClassificationItemStateComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public status: string = 'basic';

  constructor(private router: Router) {}

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    const paramsStatus = params.hasOwnProperty('statusPath') ? Objects.safeGetValue(this.params.data, this.params['statusPath'], 'basic') : 'basic';
    let type = ClassifiedItemTypes[paramsStatus];
    this.params.value = type.label;
    if (this.params.hasOwnProperty('statusRules')) {
      this.status = Values.getLabel(type.value, this.params['statusRules'], 'value', 'status') ;
    } else {
      this.status = this.status;
    }
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const paramsStatus = this.params.hasOwnProperty('statusPath') ? Objects.safeGetValue(this.params.data, this.params['statusPath'], 'basic') : 'basic';

    if (this.params.value == '') {
      let type = ClassifiedItemTypes[paramsStatus];
      this.params.value = type.label;
      if (this.params.hasOwnProperty('statusRules')) {
        this.status = Values.getLabel(type.value, this.params['statusRules'], 'value', 'status') ;
      } else {
        this.status = this.status;
      }
    } else {
      if (this.params.hasOwnProperty('statusRules')) {
        this.status = Values.getLabel(paramsStatus, this.params['statusRules'], 'value', 'status') ;
      } else {
        this.status = this.status;
      }
    }

  }

  ngOnInit() {}

}
